module.exports = __webpack_public_path__ + "img/google-play-badge-300.2b96a76e.png";